export default {
  namespaced: true,
  action_plan: {
    validatedBy: 'Validated by',
    tasks: 'Tasks',
    userValidated: 'Valid user',
    validatedDate: 'Validation date',
    validated: 'Validated',
    validate: 'Validate',
    assignUsers: 'Assign users',
    deadline: 'Deadline',
    deadlineOverdue: 'The task is overdue by {days} day(s)',
    deadlineToday: 'The task is due today',
    deadlineRemaining: '{days} day(s) remaining to complete the task',
    title: 'Action plan | Action plans',
    label: 'Action plan | Action plans',
    messages: {
      flowchart_not_ready: 'The flowchart editor is still loading. Please try again in a few seconds.',
      alarm_type_required: 'Select at least one alarm type.'
    },
    answeredDate: 'Answered date',
    openedDate: 'Opened date',
    start_modal: {
      title: 'The "{name}" action plan will be started'
    },
    replace_modal: {
      title: 'The active action plan will become "{name}"',
      description: 'Previous action plans will be disabled and visible in history.',
    },
    fields: {
      name: {
        label: 'Action plan name',
        placeholder: 'Action plan name'
      },
      default: {
        label: "Action plan by default"
      },
      all_alarm_types: {
        label: "All alarms active"
      },
      action_plan_status: {
        label: 'Status',
        options: {
          attending: 'Attending',
          waiting: 'Waiting',
        }
      }
    },
    nodes: {
      decision: {
        name: 'Decision',
        config: {
          question: 'Question',
          yes: 'Yes',
          no: 'No',
          new_output: 'Answer',
          add_output: 'Add answer',
          remove_output: 'Remove answer',
        }
      },
      terminate: {
        name: 'Terminate'
      }
    },
    viewer: {
      preview: "preview",
      answer: 'Answer',
      comments: 'Comments',
      execute_command: 'Execute command',
      execute: 'Execute',
      completed: 'Ready',
      error: 'Error',
      continue: 'Continue',
      finalized: 'Finalized',
      start_form: 'Start form',
      response_form_id_missing:
        'The server response did not include a form id. Check the API or contact support.',
      drag_form_hint: 'Drag to a grid slot to open the form here',
      advance: 'Advance',
      form_not_answered: 'The form has not been answered',
      form_answered_success: 'Form verified successfully',
      executed_success: 'Command executed successfully',
      executed_error: 'An error occurred while executing the command',
      notify: 'Notify',
      panel_failure_title: 'Panel failure',
      panel_failure_yes: 'Yes',
      panel_failure_no: 'No',
      panel_failure_answered_no: 'No panel failure',
      panel_failure_comment: 'Notification comment',
      panel_failure_comment_hint:
        'This comment will be sent in the notification to users with the action plan alarms permission.',
      panel_failure_notified: 'Panel failure notification sent',
    },
    list: {
      title: 'Action plan Logs',
      filters: {
        tenants: 'Tenants',
        start_date: "From",
        end_date: "To",
      },
      cols: {
        col1: 'Name',
        col2: 'User',
        col3: 'Tenant',
        col4: 'Alarm',
        col5: 'Date',
      }
    },
    documentTable: {
      name: 'Document Name',
      description: 'Description',
      tenant: 'Tenant',
      view: 'Visualize',
      created_at: 'Created at',
      updated_at: 'Updated at'
    },
    documentActionPlan: {
      title: 'Documents of Action Plan',
      addDocument: 'Add Document',
      document: 'Document',
      view: 'Visualize',
    }
  },
}
